"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InboxRulesOption_1 = require("owa-inbox-rules-option/lib/InboxRulesOption");
var rulesSubCategory = {
    key: 'rules',
    titleStringKey: 'optionSubcategory_rules',
    options: [InboxRulesOption_1.default],
};
exports.default = rulesSubCategory;
//# sourceMappingURL=rulesSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/rulesSubCategory.js
// module id = 5161
// module chunks = 2